<template>
  <div>
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('jobManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="jobManageInfo.conditions" class="flex justify-start">
        <el-form-item>
          <el-input v-model="jobManageInfo.conditions.taskId" :placeholder="$t('jobManage.enterTaskId')" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="jobManageInfo.conditions.taskName" :placeholder="$t('jobManage.enterTaskName')"
            clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="jobManageInfo.conditions.templateName" :placeholder="$t('jobManage.selectTemplateName')"
            clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_queryJobMethod()">
            <i class="el-icon-search"></i>
            {{ $t('jobManage.query') }}
          </el-button>
          <el-button @click="_resetJobMethod()">
            <i class="el-icon-refresh"></i>
            {{ $t('jobManage.reset') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('jobManage.timedTask') }}</span>
        <el-button type="primary" size="small" class="float-right" @click="_openAddJobModal()">
          <i class="el-icon-plus"></i>
          {{ $t('jobManage.add') }}
        </el-button>
      </div>
      <el-table :data="jobManageInfo.jobs" border style="width: 100%">
        <el-table-column prop="taskName" :label="$t('jobManage.taskName')" align="center" />
        <el-table-column prop="taskCron" :label="$t('jobManage.runTime')" align="center" />
        <el-table-column prop="templateName" :label="$t('jobManage.templateName')" align="center" />
        <el-table-column prop="createTime" :label="$t('jobManage.createTime')" align="center" />
        <el-table-column :label="$t('jobManage.status')" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === '002' ? 'success' : 'info'">
              {{ scope.row.state === '002' ? $t('jobManage.running') : $t('jobManage.stopped') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('jobManage.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state === '001'" size="mini" type="primary" @click="_openStartJob(scope.row)">
              {{ $t('jobManage.start') }}
            </el-button>
            <el-button v-if="scope.row.state === '002'" size="mini" type="warning" @click="_openStopJob(scope.row)">
              {{ $t('jobManage.stop') }}
            </el-button>
            <el-button size="mini" @click="_openEditJobModel(scope.row)">
              {{ $t('jobManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteJobModel(scope.row)">
              {{ $t('jobManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="jobManageInfo.conditions.page"
        :page-size="jobManageInfo.conditions.row" layout="total, prev, pager, next" :total="jobManageInfo.total" />
    </el-card>

    <add-job ref="addJob" @refresh="_listJobs" />
    <edit-job ref="editJob" @refresh="_listJobs" />
    <delete-job ref="deleteJob" @refresh="_listJobs" />
  </div>
</template>

<script>
import { listTasks, startTask, stopTask } from '@/api/dev/jobApi'
import AddJob from '@/components/dev/addJob/addJob'
import EditJob from '@/components/dev/editJob/editJob'
import DeleteJob from '@/components/dev/deleteJob/deleteJob'

export default {
  name: 'JobManage',
  components: {
    AddJob,
    EditJob,
    DeleteJob
  },
  data() {
    return {
      jobManageInfo: {
        jobs: [],
        total: 0,
        conditions: {
          taskId: '',
          taskName: '',
          templateName: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listJobs()
  },
  methods: {
    async _listJobs() {
      try {
        const res = await listTasks(this.jobManageInfo.conditions)
        this.jobManageInfo.jobs = res.data
        this.jobManageInfo.total = res.total
      } catch (error) {
        console.error('获取任务列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.jobManageInfo.conditions.page = val
      this._listJobs()
    },
    _openAddJobModal() {
      this.$refs.addJob.open()
    },
    _openEditJobModel(job) {
      this.$refs.editJob.open(job)
    },
    _openDeleteJobModel(job) {
      this.$refs.deleteJob.open(job)
    },
    async _openStartJob(job) {
      try {
        await startTask({ taskId: job.taskId })
        this.$message.success(this.$t('jobManage.startSuccess'))
        this._listJobs()
      } catch (error) {
        console.error('启动任务失败:', error)
      }
    },
    async _openStopJob(job) {
      try {
        await stopTask({ taskId: job.taskId })
        this.$message.success(this.$t('jobManage.stopSuccess'))
        this._listJobs()
      } catch (error) {
        console.error('停止任务失败:', error)
      }
    },
    _queryJobMethod() {
      this.jobManageInfo.conditions.page = 1
      this._listJobs()
    },
    _resetJobMethod() {
      this.jobManageInfo.conditions = {
        taskId: '',
        taskName: '',
        templateName: '',
        page: 1,
        row: 10
      }
      this._listJobs()
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}
</style>